import { FormattedNumber } from 'react-intl';
import React, { Component } from 'react';

import './styles/Stat.css';
import { color, math } from '../utilities';
import EXPERIENCE_TABLE from '../constants/experienceTable';
import SkillIcon from './SkillIcon';

class Stat extends Component {
  getExperience = level => EXPERIENCE_TABLE.find(EXP => EXP.level === level);

  getMaxProgress = exp => {
    const expMax = this.getExperience(127).exp;
    return math.fixed((exp / expMax) * 100);
  };

  getLevelProgress = (level, exp) => {
    const currentLevel = this.getExperience(level) || {};
    const nextLevel = level < 127 ? this.getExperience(level+1) || {} : {};

    if (currentLevel.level === 127) {
      return { needed: 0, progress: 0 };
    }

    return {
      needed: nextLevel.exp - exp,
      progress: (exp - currentLevel.exp) / (nextLevel.exp - currentLevel.exp) * 100
    };
  };

  render() {
    const { formatting, stat, isHighestLevel, isPlaceholder } = this.props;

    const getFormatting = formatting => {
      if (formatting === 'tiny') {
        return 'tiny';
      } else if (formatting === 'compact') {
        return 'compact';
      }

      return '';
    }

    const getProgress = exp => {
      if (this.getMaxProgress(exp) > 0) {
        return [
          `,\u00a0`,
          <FormattedNumber value={this.getMaxProgress(exp)} />,
          `%`
        ];
      }
      return '';
    };

    if (isPlaceholder) {
      const randomLevel = Math.floor(Math.random() * 99);
      return (
        <div className="stat-group group-tight loading" style={{ 'backgroundColor': color.getSkillColor(randomLevel) }}>
          <div className="stat-content">
            <h5 className="stat-name narrow">
              &nbsp;
            </h5>
            {formatting === 'standard' && <div className="row">
              <div className="stat-detail columns collapse shrink">
                <p>&nbsp;</p>
              </div>
              <div className="stat-detail columns collapse shrink">
                <p>&nbsp;</p>
              </div>
            </div>}
          </div>
        </div>
      );
    }

    return (
      <div className={`stat-group group-tight ${getFormatting(formatting)} ${isHighestLevel ? 'highest' : ''}`} style={{ 'backgroundColor': color.getSkillColor(stat.details.level) }}>
        <div className="stat-progress" style={{'width': `${this.getLevelProgress(stat.details.level, stat.details.exp).progress}%`}}></div>
        <div className="stat-content">
          <h5 className="stat-name narrow">
            <SkillIcon icon={stat.key} name={stat.name} />
            { stat.name } { stat.details.level < 127 ? [` (${stat.details.level}`, getProgress(stat.details.exp), `)`] : ' 👑 ' }
          </h5>
          {formatting === 'standard' && <div className="row">
            <div className="stat-detail columns collapse shrink">
              <p><strong>EXP:</strong> <FormattedNumber value={stat.details.exp} />/{stat.details.level < 127 ? <FormattedNumber value={this.getExperience(stat.details.level+1).exp} /> : '∞'}</p>
            </div>
            <div className="stat-detail columns collapse shrink">
              <p><strong>TO GO:</strong> <FormattedNumber value={this.getLevelProgress(stat.details.level, stat.details.exp).needed} /></p>
            </div>
          </div>}
        </div>
      </div>
    );
  }
}

export default Stat;



// WEBPACK FOOTER //
// ./src/components/Stat.js